<template>
    <div id="app">
        <div id="Return_Bar">
            <i class="el-icon-arrow-left"></i>
            <div @click="isreturn" class="isreturn">返回</div>
        </div>
        <div id="text">
            <div class="step-list" ref="asx" v-for="(c, key) in courseList" :key="key">
                <div class="step-list_top">
                    <div class="list_top_left">
                        <div class="circle"
                            :class="{ circle: c.passState == 'Passed', othercircle: c.passState == 'Ongoing' || c.passState == null }">
                            <div v-if="courseList.length != 1">{{ key + 1 }}</div>
                        </div>
                        {{ c.courseName }}
                        <div :class="c.passState == 'Passed' ? 'isgreen' : 'isred'">
                            {{ c.passState == "Passed" && c.passState != "null" ? "已完成" : "未完成" }}
                        </div>
                    </div>
                    <div class="list_top_right">
                        <template v-if="c.unlock == true">
                            <div class="spb_button" v-if="c.passState == 'Ongoing' && c.courseType != 'Exam'" @click="goStudy(c)">点击学习</div>
                            <div class="spb_button" v-if="c.passState == 'Passed' && c.courseType  != 'Exam'" @click="goStudy(c)">重新学习</div>
                            <div class="spb_button" v-if="c.passState == null && c.unlock == true && c.courseType != 'Exam'" @click="goStudy(c)">点击学习</div>
                            <div class="spb_button" v-if="c.courseType == 'Exam' && c.passState != 'Passed'" @click="goStudy(c)">开始考试</div>
                            <div class="spb_button" v-if="c.courseType == 'Exam' && c.passState == 'Passed'" @click="goStudy(c)">重新考试</div>
                        </template>
                        <div v-else class="lock"></div>
                    </div>
                </div>
                <div>
                    <div class="step-list_under" v-if="c.description != ''">
                        <div v-html="c.description" style="width:80%"></div>
                    </div>
                </div>
                <div v-if="key != 0" class="top_line"
                    :class="{ 'top_isCheck': c.passState == 'Passed' || c.passState == 'Ongoing', 'top_noCheck': c.passState == null }">
                </div>
                <div v-if="courseList.length > 1 && key != courseList.length - 1"
                    :class="{ line: c.passState == 'Passed', otherline: c.passState == 'Ongoing' || c.passState == null }">
                </div>
            </div>
        </div>
    </div>
</template>
<script>

export default {
    name: "courseList",
    data() {
        return {
            categoryId: this.$route.query.categoryId,
            courseList: [],//四级列表
            tjkId: this.$route.query.tjkId || 12345678,//淘金客id
            tabIndex: null,//二级tab的index
        };

    },
    // ... 其他代码
    beforeRouteEnter(to, from, next) {
        next(vm => {
        // 每次进入页面时都刷新数据
         vm.Lv3Courses();
        });
    },
    methods: {
        // 返回按钮
        isreturn() {
            localStorage.setItem('needSetDefaultTab2', 'false');
            this.tabIndex = localStorage.getItem('tabIndex');
            this.$router.push({
                path: '/train/index',
                query: {
                    tabIndex: this.tabIndex,
                    condition: false
                }
            });
        },
        // 获取三级课程列表
        Lv3Courses() {
            this.$http.post(API_ROOT.college + "/majors/queryCourseViewNewXlkCategoryId", { categoryId: this.categoryId })
                .then((res) => {
                    const result = res.data;
                    if (result.success) {
                        this.courseList = result.data.courseViewList;
                    } else {
                        this.$alert(result.msg);
                    }
                }, (res) => {
                    this.$alert("AJAX请求接口异常！");
                });
        },
        // 点击学习
        goStudy(c) {
            const assitantType = c.assitantType;
            if (assitantType === "qianniuplugin") {
                this.$router.push({name: 'fbtQianniu', query:{courseId:c.courseId} }); return;
            } else if (assitantType === "qianniupluginexam") {
                this.$router.push({name: 'fbtQianniuExam', query:{courseId:c.courseId} }); return;
            }else if (assitantType === "jingmaiplugin") {
                this.$router.push({name: 'fbtJingmai', query:{courseId:c.courseId} }); return;
            }else if (assitantType === "jingmaipluginexam") {
                this.$router.push({name: 'fbtJingmaiExam', query:{courseId:c.courseId} }); return;
            }else if (assitantType === "feigeplugin") {
                this.$router.push({name: 'fbtDoudian', query:{courseId:c.courseId} }); return;
            }else if (assitantType === "feigepluginexam") {
                this.$router.push({name: 'fbtDoudianExam', query:{courseId:c.courseId} }); return;
            }else {
                var courseId = c.courseId;
                if (c.courseType == "Exam") {
                  var trainFlag = null;
                  if (c.assitantType == 'fbtExamCourse') {
                    trainFlag = 'fbtTrain'
                  }
                  window.location.href = '/tjkStudy/train/examDetail?courseId=' + c.courseId + '&trainFlag=' + trainFlag + '&assitantType=' + c.assitantType + '&tjkId=' + this.tjkId;
                } else {
                  this.$http.post(API_ROOT.college + "/course/getKnowledgeListXlk", { courseId: courseId }).then((res) => {
                      var result = res.data;
                      if (result.success) {
                          if (result.data.knowledgeRecordFullList.length >= 1 ){
                              this.$router.push({
                                  path: '/train/Secondarylist',
                                  query: { courseId: courseId,Level:4, tjkId:this.tjkId}
                              })
                          }
                      } else {
                          this.$alert(result.msg);
                      }
                  }, (res) => {
                      this.$alert(
                          "AJAX请求接口异常（/assitantTrain/saveWebLoginAndAssitantDown）！"
                      );
                  }
                  );
                }
            }
        },
    }
};
</script>
<style lang='less' scoped>
.isreturn {
    color: #000;
    cursor: pointer;
}

/deep/.el-icon-arrow-left {
    color: #000;
}

.step-list {
    margin-bottom: 20px;
    background: #fff;
    border-radius: 5px;
    padding: 19px 20px 20px 60px;
    position: relative;
}

.step-list_top {
    display: flex;
    justify-content: space-between;
}

.list_top_left {
    display: flex;
    font-size: 16px;
    color: #262626;
    font-weight: bold;
    position: relative;
    left: -20px;
}

.isred {
    color: #E53434;
    margin-right: 10px;
    font-weight: 600;
    font-size: 12px;
    padding: 0px 3px;
    border: 1px solid #E53434;
    border-radius: 4px;
    margin-left: 9px;
    margin-top: 4px;
    background: #FBE5E5;
    height: 18px;
    line-height: 15px;
}

.isgreen {
    color: #14C034;
    margin-right: 10px;
    font-weight: 600;
    font-size: 12px;
    padding: 0px 3px;
    border: 1px solid #39CA54;
    border-radius: 4px;
    margin-left: 9px;
    margin-top: 4px;
    background: #D9F4DE;
    height: 18px;
    line-height: 15px;
}

/deep/.el-button--small {
    padding: 9px 24px !important;
    border-radius: 6px;
}

/deep/.el-button--primary {
    background-color: #497af2;
}

.step-list_under {
    margin-top: 15px;
    background: #f5f6f7;
    padding: 19px 20px 20px 19px;
    font-size: 13px;
    overflow: hidden;
    color: #262626;
}

.circle {
    width: 20px;
    height: 20px;
    background: #497AF2;
    border-radius: 20px;
    position: relative;
    z-index: 1;
    display: inline-flex;
    justify-content: center;
    align-items: center;
    transition: 0.15s ease-out;
    left: -20px;
    top: 2px;
    color: #fff;
    font-weight: normal;
    line-height: 20px;
}

.othercircle {
    width: 20px;
    height: 20px;
    background: #BBBBBB;
    border-radius: 20px;
    position: relative;
    z-index: 1;
    display: inline-flex;
    justify-content: center;
    align-items: center;
    transition: 0.15s ease-out;
    left: -20px;
    top: 2px;
    color: #fff;
    font-weight: normal;
    line-height: 20px;
}

.line {
    width: 2px;

    top: 41px;
    bottom: -20px;
    left: 29px;
    position: absolute;
    border-color: inherit;
    background-color: #1684fc;
    z-index: 99;
}

.otherline {
    width: 2px;

    top: 41px;
    bottom: -20px;
    left: 29px;
    position: absolute;
    border-color: inherit;
    background-color: #BBBBBB;
    z-index: 99;
}

#app {
    height: 100%;
    box-sizing: border-box;
}

#Return_Bar {
    padding-left: 21px;
    display: flex;
    padding-top: 10px;
    padding-bottom: 15px;
    width: 100%;
}

/deep/.el-icon-arrow-left {
    margin-top: 5px;
}

#text {
    background: #f6f5f8;
    width: 100%;
    height: 100%;
    padding: 20px 20px;
}



.lock {
    background: url('../../../assets/images/lock.png') no-repeat center;
    background-size: cover;
    width: 22px;
    height: 22px;
    position: absolute;
    right: 20px;
}

.description {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis
}

.sp_button {
    width: 95px;
    height: 28px;
    background: #BFD0FB;
    border-radius: 6px;
    font-size: 14px;
    font-family: Source Han Sans CN;
    font-weight: 500;
    color: #497AF2;
    text-align: center;
    line-height: 28px;
    cursor: pointer;
    letter-spacing: 1px;
}

.spb_button {
    width: 95px;
    height: 28px;
    background: #497AF2;
    border-radius: 6px;
    font-size: 14px;
    font-family: Source Han Sans CN;
    font-weight: 500;
    color: #FFFFFF;
    text-align: center;
    line-height: 28px;
    cursor: pointer;
    margin-left: 10px;
    letter-spacing: 1px;
}

.sph_button {
    width: 95px;
    height: 28px;
    background: #ff2323;
    border-radius: 6px;
    font-size: 14px;
    font-family: Source Han Sans CN;
    font-weight: 500;
    color: #FFFFFF;
    text-align: center;
    line-height: 28px;
    cursor: pointer;
    margin-left: 10px;
    letter-spacing: 1px;
}

.list_top_right {
    display: flex;
}


.top_line {
    position: absolute;
    top: 0;
    left: 29px;
    width: 2px;
    height: 21px;
}

.top_isCheck {
    background: #1684fc;
}

.top_noCheck {
    background: #BBBBBB;
}

/deep/.el-dialog--center .el-dialog__body {
    text-align: center;
}
</style>


// WEBPACK FOOTER //
// ./src/page/train/FBT/courseList.vue